import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import ar from "./locales/ar.json";
import en from "./locales/en.json";
import it from "./locales/it.json";

const isBrowser = typeof document !== "undefined";
const i18nInstance = isBrowser ? i18n.use(LanguageDetector) : i18n;

i18nInstance.use(initReactI18next).init({
    resources: {
      en: { translation: en },
      it: { translation: { ...en, ...it } },
      ar: { translation: { ...en, ...ar } },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "it", "ar"],
    interpolation: {
      escapeValue: false,
    },
    detection: isBrowser
      ? {
          order: ["localStorage", "navigator"],
          caches: ["localStorage"],
          lookupLocalStorage: "GET2VACATIONS_language",
        }
      : undefined,
  });

function syncDocumentLanguage(lng: string) {
  if (typeof document === "undefined") {
    return;
  }

  const isRtl = lng === "ar";
  document.documentElement.dir = isRtl ? "rtl" : "ltr";
  document.documentElement.lang = lng;
}

if (isBrowser) {
  i18n.on("languageChanged", (lng: string) => {
    syncDocumentLanguage(lng);
  });

  const currentLanguage = i18n.language || "en";
  syncDocumentLanguage(currentLanguage);
}

export default i18n;
